// ProtectedRoute.jsx
// Wraps any route that requires auth.
// If not logged in → redirect to / and open auth modal.

import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, authLoading, showAuthModal } = useAuth();

  // Still checking auth state — show nothing yet
  if (authLoading) return null;

  // Not logged in — redirect to landing and open signup modal
  if (!user) {
    return <Navigate to="/" replace state={{ openAuth: true }} />;
  }

  return children;
}